import Styles from './styles.module.css';
import { offerCount } from '../../../0.functions/offers';
import React, { useState } from 'react';
import { MdMenuBook } from "react-icons/md";
import { HiNewspaper } from "react-icons/hi2";
import { Applicant, defaultApplicant, formatApplicant, SchoolUserData } from 'src/type';
import DefaultImage from './../../../../image/default/account.png';
import Resume from '../../../../salon/desktop/info/resume/index';
import Report from './report/index';
import { doc, DocumentData, DocumentSnapshot, getDoc, getFirestore } from 'firebase/firestore';

type SchoolItemProps = {
  data: SchoolUserData;
  setType: React.Dispatch<React.SetStateAction<any>>;
  schoolId: string;
};

const SchoolItem: React.FC<SchoolItemProps> = ({ data, setType, schoolId }) => {

  // 内定承諾は、学生が登録しても学校が登録しても1人1件。0件でも開ける(学校で内定を登録するため)
  const offers = offerCount(data, schoolId);


  const db = getFirestore();

  const [ applicant, setApplicant ] = useState<Applicant>(defaultApplicant);
  const [ applicantToggle, setApplicantToggle ] = useState<boolean>(false);

  const [ report, setReport ] = useState<string>("");

  const fetchResume = async (
    uid: string
  ): Promise<DocumentSnapshot<DocumentData> | null> => {
    const resumeRef = doc(db, "users", uid, "resume", "main");
    const resumeSnap = await getDoc(resumeRef);

    if (!resumeSnap.exists()) {
      return null;
    }

    return resumeSnap;
  };

  const handleFetchResume = async (uid: string) => {
    const snap = await fetchResume(uid);

    if (!snap) return;

    const applicant = formatApplicant(snap);
    setApplicant(applicant);
    setApplicantToggle(true);
  };

  return (
    <>
    <div className={Styles.table}>

      <img className={Styles.image}
        src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/profiles%2Fresize_images%2F${data.uid}_500x500?alt=media&token=?`} 
        onError={(e) => {
          e.currentTarget.src = DefaultImage;
        }} />

      <h2 className={Styles.name} onClick={() => console.log(data.uid)}>{data.education.name}</h2>
      
      <div style={{ flex: "1", alignItems: "center" }}></div>

      <h4 className={Styles.items}
        style={(data?.analytics?.postCount ?? 0) >= 5 ? { backgroundColor: "#D6EAE2" } : (data?.analytics?.postCount ?? 0) >= 3 ? { backgroundColor: "#FFF6CB" } : { backgroundColor: "#FDE9ED" }}
        onClick={() => { if ((data?.analytics?.postCount ?? 0) !== 0) { setType({ uid: data.uid, type: "post" }) }}}>
        {data?.analytics?.postCount ?? 0}枚
      </h4>

      <h4 className={Styles.items}
        style={(data?.analytics?.pvCount ?? 0) >= 51 ? { backgroundColor: "#D6EAE2" } : (data?.analytics?.pvCount ?? 0) >= 11 ? { backgroundColor: "#FFF6CB" } : { backgroundColor: "#FDE9ED" }}>
        {data?.analytics?.pvCount ?? 0}回
      </h4>

      <h4 className={Styles.items}
        style={(data?.activity?.recruitSaves?.length ?? 0) >= 8 ? { backgroundColor: "#D6EAE2" } : (data?.activity?.recruitSaves?.length ?? 0) >= 3 ? { backgroundColor: "#FFF6CB" } : { backgroundColor: "#FDE9ED" }}
        onClick={() => { if ((data?.activity?.recruitSaves?.length ?? 0) !== 0) { setType({ uid: data.uid, type: "save" }) }}}>
        {data?.activity?.recruitSaves?.length ?? 0}個
      </h4>

      <h4 className={Styles.items}
        style={(data?.activity?.recruitVisitList?.length ?? 0) >= 5 ? { backgroundColor: "#D6EAE2" } : (data?.activity?.recruitVisitList?.length ?? 0) >= 3 ? { backgroundColor: "#FFF6CB" } : { backgroundColor: "#FDE9ED" }}
        onClick={() => { if ((data?.activity?.recruitVisitList?.length ?? 0) !== 0) { setType({ uid: data.uid, type: "visit" }) }}}>
        {data?.activity?.recruitVisitList?.length ?? 0}件
      </h4>

      <h4 className={Styles.items}
        style={(data?.analytics?.applyStatusCount?.志望先 ?? 0) >= 3 ? { backgroundColor: "#D6EAE2" } : (data?.analytics?.applyStatusCount?.志望先 ?? 0) >= 1 ? { backgroundColor: "#FFF6CB" } : { backgroundColor: "#FDE9ED" }}
        onClick={() => { if ((data?.analytics?.applyStatusCount?.志望先 ?? 0) !== 0) { setType({ uid: data.uid, type: "apply.志望先" }) }}}>
        {data?.analytics?.applyStatusCount?.志望先 ?? 0}件
      </h4>

      <h4 className={Styles.items}
        style={(data?.analytics?.applyStatusCount?.応募済み ?? 0) >= 2 ? { backgroundColor: "#D6EAE2" } : (data?.analytics?.applyStatusCount?.応募済み ?? 0) >= 1 ? { backgroundColor: "#FFF6CB" } : { backgroundColor: "#FDE9ED" }}
        onClick={() => { if ((data?.analytics?.applyStatusCount?.応募済み ?? 0) !== 0) { setType({ uid: data.uid, type: "apply.応募済み" }) }}}>
        {data?.analytics?.applyStatusCount?.応募済み ?? 0}件
      </h4>

      <h4 className={Styles.items}
        style={offers >= 1 ? { backgroundColor: "#D6EAE2", cursor: "pointer" } : { backgroundColor: "#FDE9ED", cursor: "pointer" }}
        title="内定を見る・登録する"
        onClick={() => setType({ uid: data.uid, type: "apply.内定承諾" })}>
        {offers}件
      </h4>

      <div style={{ flex: "1", alignItems: "center" }}></div>
      
      <a style={{ marginRight: "70px" }} 
        onClick={() => { if (data?.activity?.resume) { handleFetchResume(data.uid) }}}>
        <MdMenuBook className={Styles.icon} style={data?.activity?.resume ? {cursor: "pointer"} : {color: "#EBEBEB"}} />
      </a>

      <a style={data?.activity?.report ? {marginRight: "70px"} : {marginRight: "70px"}} 
        onClick={() => { if (data?.activity?.report) { setReport(data.uid) }}}>
        <HiNewspaper className={Styles.icon} style={data?.activity?.report ? {cursor: "pointer"} : {color: "#EBEBEB"}} />
      </a>

    </div>

    {applicantToggle && (
    <div className={Styles.box}>
      <div>
        <div className={Styles.box_black} onClick={() => setApplicantToggle(false)}></div>
        <div className={Styles.box_info}>
          <Resume applicant={applicant}
            documentData={{
              isCompleted: false,
              visit: false,
              document: true,
              resume: true,
              question: false,
              coordinate: false,
              questionCount: 0,
              question1: '',
              question2: '',
              question3: '',
              otherDocument: false,
              otherDocumentCount: 0,
              otherDocument1: '',
              otherDocument2: '',
              otherDocument3: '',
            }} />
        </div>
      </div>
    </div> )}

    {report !== "" && (
      <Report report={report} setReport={setReport} />
    )}
    
    </>
  );
}

export default SchoolItem;
